import { Injectable } from '@angular/core';
import { BaseController } from '@app/common/modules/base/base.controller';
import { PneuModel } from '@app/data/pneu/models';
import { PneuRepository } from '@app/data/pneu/pneu.repository';

@Injectable()
export class PneusController extends BaseController<PneuModel> {
  constructor(pneuRepository: PneuRepository) {
    super(pneuRepository);
  }
}
